import { render, staticRenderFns } from "./b_TicketsStatistics.vue?vue&type=template&id=7ca8602c&scoped=true&"
import script from "./b_TicketsStatistics.vue?vue&type=script&lang=js&"
export * from "./b_TicketsStatistics.vue?vue&type=script&lang=js&"
import style0 from "./b_TicketsStatistics.vue?vue&type=style&index=0&id=7ca8602c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca8602c",
  null
  
)

export default component.exports